import { Link } from 'react-router-dom'
import { Search, Bell, User, BookOpen, Megaphone, Users, LogIn, UserPlus, Shield } from 'lucide-react'
import { useAuth } from '../../hooks/useAuth'

export default function Header() {
  const { user, hasAnyRole } = useAuth()
  const isAdminUser = user && hasAnyRole(['superadmin', 'admin', 'moderator', 'editor'])
  return (
    <header className="sticky top-0 z-50 w-full bg-white border-b border-neutral-200 shadow-sm">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="font-heading font-bold text-xl text-neutral-700">
              Learn to <span className="text-education">Lead</span>{' '}
              <span className="text-action">Change</span>
            </div>
          </Link>

          {/* Barra de búsqueda central - solo si el usuario está autenticado */}
          {user && (
            <div className="hidden md:flex flex-1 max-w-2xl">
              <div className="relative w-full">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-neutral-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Buscar cursos, campañas, comunidad..."
                  className="w-full pl-10 pr-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-education focus:border-transparent"
                />
              </div>
            </div>
          )}

          {/* Navegación principal - solo si el usuario está autenticado */}
          {user && (
            <nav className="hidden lg:flex items-center space-x-6">
              <Link
                to="/dashboard"
                className="text-neutral-700 hover:text-education transition-colors font-medium"
              >
                Mi Progreso
              </Link>
              <Link
                to="/cursos"
                className="flex items-center space-x-1 text-neutral-700 hover:text-education transition-colors"
              >
                <BookOpen className="w-4 h-4" />
                <span className="font-medium">Cursos</span>
              </Link>
              <Link
                to="/campanas"
                className="flex items-center space-x-1 text-neutral-700 hover:text-action transition-colors"
              >
                <Megaphone className="w-4 h-4" />
                <span className="font-medium">Campanas</span>
              </Link>
              <Link
                to="/comunidad"
                className="flex items-center space-x-1 text-neutral-700 hover:text-community transition-colors"
              >
                <Users className="w-4 h-4" />
                <span className="font-medium">Comunidad</span>
              </Link>
            </nav>
          )}

          {/* Acciones de usuario */}
          <div className="flex items-center space-x-3">
            {user ? (
              <>
                {isAdminUser && (
                  <Link
                    to="/admin"
                    className="flex items-center space-x-2 px-3 py-2 text-purple-600 border border-purple-600 rounded-lg hover:bg-purple-600 hover:text-white transition-colors font-medium"
                    title="Panel Administrativo"
                  >
                    <Shield className="w-4 h-4" />
                    <span className="hidden md:inline">Admin</span>
                  </Link>
                )}
                <button className="relative p-2 text-neutral-700 hover:text-education transition-colors">
                  <Bell className="w-5 h-5" />
                  <span className="absolute top-1 right-1 w-2 h-2 bg-urgency rounded-full"></span>
                </button>
                <Link
                  to="/perfil"
                  className="flex items-center space-x-2 p-2 rounded-lg hover:bg-neutral-100 transition-colors"
                >
                  <div className="w-8 h-8 bg-education rounded-full flex items-center justify-center text-white">
                    <User className="w-5 h-5" />
                  </div>
                </Link>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="flex items-center space-x-2 px-4 py-2 text-education border border-education rounded-lg hover:bg-education hover:text-white transition-colors font-medium"
                >
                  <LogIn className="w-4 h-4" />
                  <span>Iniciar sesion</span>
                </Link>
                <Link
                  to="/registro"
                  className="flex items-center space-x-2 px-4 py-2 bg-education text-white rounded-lg hover:bg-education/90 transition-colors font-medium"
                >
                  <UserPlus className="w-4 h-4" />
                  <span>Registrate</span>
                </Link>
              </>
            )}
          </div>
        </div>

        {/* Barra de progreso dual (si el usuario está autenticado) */}
        {user && (
          <div className="mt-3 flex items-center space-x-2">
            <div className="flex-1 bg-neutral-200 rounded-full h-2 overflow-hidden">
              <div className="flex h-full">
                <div
                  className="bg-education"
                  style={{ width: '65%' }}
                  title="Progreso educativo: 65%"
                ></div>
                <div
                  className="bg-action"
                  style={{ width: '35%' }}
                  title="Progreso participación: 35%"
                ></div>
              </div>
            </div>
            <span className="text-xs text-neutral-600 font-mono whitespace-nowrap">
              Change Score: 450
            </span>
          </div>
        )}
      </div>
    </header>
  )
}
